(ns nosco.ui.loading
  (:require
   ["lottie-light-react$default" :as Lottie]
   ["react" :as React]
   [hx.hooks :refer [useEffect] :as hooks]
   [hx.react :refer [defnc]]
   [nosco.colors :as colors]
   [nosco.i18n.translate :as t]
   [nosco.icons2 :as icons2]
   [nosco.react]
   [nosco.shared.layouts :as shared-layouts]
   [nosco.ui.empty-states :as empty-states]
   [nosco.util :as util]
   [shadow.resource :as shadow-resource]
   [nosco.ui.text :as text]))

(def loading-lottie
  (js/JSON.parse (shadow-resource/inline "animations/main/success-state.json")))

(defn- play-segments [^js lottie frames force]
  (when lottie
    (.playSegments lottie frames force)))

(defnc LoadingAnimation [{:keys [finished wh on-complete]
                          :or {wh "64px"}}]
  (let [lottie-ref (React/useRef nil)
        on-complete (fn []
                      (.goToAndStop (.-current lottie-ref)
                                    30
                                    true)

                      (when on-complete
                        (js/setTimeout #(on-complete) 5)))

        ;; this needs to be stable to avoid re-renders, so we stick it in a ref
        initial-segment (React/useRef #js [0 29])]

    (hooks/useEffect (fn []

                       (when finished

                         (play-segments
                          (.-current lottie-ref)
                          #js [90 120] true)))

                     [finished])
    [Lottie {:animationData loading-lottie
             :onComplete on-complete
             :lottieRef lottie-ref
             :initialSegment (.-current initial-segment)
             :autoplay true
             :loop (not finished)
             :style #js {:width wh
                         :height wh}}]))

(defnc LoadingScreen [{:keys [img headings descriptions state actions on-complete]}]

  {:pre [(#{:loading :success :error} state)]}
  (let [description (get descriptions state)
        actions (get actions state)
        heading (get headings state)]
    [:div {:class "d-flex flex-column align-items-center justify-content-start"
           :style {:gap "24px"}}
     [empty-states/BareEmptyState
      {:img-height "140px"
       :img-src img}]
     [:div {:class "text-center"}
      [text/Text {:variant text/Heading-Xl
                  :el :div}
       heading]
      [:div {:class "mb-spacing-16"}]
      (if (string? description)
        [text/Text {:variant text/Body-Lg-Regular
                    :el :div}
         description]
        description)]
     [LoadingAnimation {:finished (#{:success :error} state)
                        :wh "42px"

                        :on-complete on-complete}]

     actions]))

(defnc Loading []
  [:div {:style {:position "relative"
                 :margin-top "3rem"
                 :height "10rem"}}
   (shared-layouts/fullscreen-loading-spinner {:loading-text (t/t "Loading...")})])

(defnc PageLoading [{:keys [prompt]}]
  (shared-layouts/fullscreen-loading-spinner {:loading-text (or prompt (t/t "Loading..."))}))

(defnc LoadingNew [props]
  [:div (nosco.react/merge-props
         {:class "m-auto d-flex justify-content-center align-items-center"}
         props)
   [:span {:class "sr-only"} "Loading..."]
   [icons2/LoadingIcon {:color colors/neutral-300
                        :class "nosco-animation-loading-rotate-360"}]])

(defnc LoadingDimmingContainer
  "Renders children in a container that will dim when loading.
  The dimming has a default delay of 0.2s only on the dimming direction,
  the undimming is immediate."
  [{:keys [children delay loading]
    :or {delay 0.2}}]

  [:div {:class ["nosco-loading-container"
                 (when loading "loading")]
         :style {:--transition-delay (str delay "s")}}
   children])

(defnc ExitWormhole [{:keys [loading-text]}]
  (useEffect (fn []
               (util/redirect (.-location js/document)))
             [])
  (shared-layouts/fullscreen-loading-spinner {:loading-text loading-text}))
